import globals from '@descope-ui/theme-globals';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';
import { TextClass } from './component/TextClass';

const globalRefs = getThemeRefs(globals);
const vars = TextClass.cssVarList;

const text = {
  [vars.hostDirection]: globalRefs.direction,
  [vars.textLineHeight]: '1.35em',
  [vars.textAlign]: 'start',
  [vars.textColor]: globalRefs.colors.surface.dark,

  variant: {
    h1: {
      [vars.fontSize]: globalRefs.typography.h1.size,
      [vars.fontWeight]: globalRefs.typography.h1.weight,
      [vars.fontFamily]: globalRefs.typography.h1.font,
    },
    h2: {
      [vars.fontSize]: globalRefs.typography.h2.size,
      [vars.fontWeight]: globalRefs.typography.h2.weight,
      [vars.fontFamily]: globalRefs.typography.h2.font,
    },
    h3: {
      [vars.fontSize]: globalRefs.typography.h3.size,
      [vars.fontWeight]: globalRefs.typography.h3.weight,
      [vars.fontFamily]: globalRefs.typography.h3.font,
    },
    subtitle1: {
      [vars.fontSize]: globalRefs.typography.subtitle1.size,
      [vars.fontWeight]: globalRefs.typography.subtitle1.weight,
      [vars.fontFamily]: globalRefs.typography.subtitle1.font,
    },
    subtitle2: {
      [vars.fontSize]: globalRefs.typography.subtitle2.size,
      [vars.fontWeight]: globalRefs.typography.subtitle2.weight,
      [vars.fontFamily]: globalRefs.typography.subtitle2.font,
    },
    body1: {
      [vars.fontSize]: globalRefs.typography.body1.size,
      [vars.fontWeight]: globalRefs.typography.body1.weight,
      [vars.fontFamily]: globalRefs.typography.body1.font,
    },
    body2: {
      [vars.fontSize]: globalRefs.typography.body2.size,
      [vars.fontWeight]: globalRefs.typography.body2.weight,
      [vars.fontFamily]: globalRefs.typography.body2.font,
    },
  },

  mode: {
    primary: {
      [vars.textColor]: globalRefs.colors.surface.contrast,
    },
    secondary: {
      [vars.textColor]: globalRefs.colors.surface.dark,
    },
    error: {
      [vars.textColor]: globalRefs.colors.error.main,
    },
    'error-dark': {
      [vars.textColor]: globalRefs.colors.error.dark,
    },
    success: {
      [vars.textColor]: globalRefs.colors.success.main,
    },
    'success-dark': {
      [vars.textColor]: globalRefs.colors.success.dark,
    },
    warning: {
      [vars.textColor]: globalRefs.colors.warning.main,
    },
    'warning-dark': {
      [vars.textColor]: globalRefs.colors.warning.dark,
    },
  },

  textAlign: {
    right: { [vars.textAlign]: 'right' },
    left: { [vars.textAlign]: 'left' },
    center: { [vars.textAlign]: 'center' },
  },

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },

  _italic: {
    [vars.fontStyle]: 'italic',
  },

  _uppercase: {
    [vars.textTransform]: 'uppercase',
  },

  _lowercase: {
    [vars.textTransform]: 'lowercase',
  },
};

export default text;
export { vars };
